import { graphql } from 'gatsby'
import React from 'react'

const Snippet: React.FC<Queries.SnippetFragment> = ({ code }) => {
  if (code === 'privacy_cookie_policy') {
    return (
      <div className="container" style={{ minHeight: '700px' }}>
        <div className="row">
          <div className="col pb-4">
            <div sp-privacy-policy-text="direct-text" sp-lang-code="en" />
          </div>
        </div>
      </div>
    )
  }
}

export default Snippet

export const query = graphql`
  fragment Snippet on DatoCmsSnippet {
    __typename
    id
    code
    navigationLabel
  }
`
